import { createAction } from 'redux-actions';
import { SocialLoginProvider } from '@wix/da-shared-react/pkg/SocialLogin/types';

export const setSocialLoginTokenId = createAction(
  'SOCIAL.SET_TOKEN',
  (provider: SocialLoginProvider, tokenId: string) => ({ provider, tokenId })
);

export const setForceRenderPage = createAction('SOCIAL.SET_FORCE_RENDER_PAGE', (page: string) => ({
  page,
}));
